import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Footer = () => {
  return (
    <footer id="contacto" className="footer mt-auto bg-white-custom border-top">
      <div className="container py-5">
        <div className="row g-4 align-items-start">
          {/* Marca */}
          <div className="col-12 col-md-4">
            <h5 className="mb-3 text-primary-custom fw-bold">Kuelly</h5>
            <p className="footer-desc mb-3">
              Soluciones inmobiliarias con transparencia y profesionalismo.
            </p>
            <div className="d-flex gap-3">
              <a
                href="https://www.kuelly.com.mx"
                className="footer-social"
                aria-label="Ir al sitio"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="fas fa-globe-americas" aria-hidden="true"></span>
              </a>
              <a
                href="mailto:direccion@kuelly.com.mx"
                className="footer-social"
                aria-label="Enviar correo"
              >
                <span className="fas fa-envelope" aria-hidden="true"></span>
              </a>
              <a
                href="tel:+524427989937"
                className="footer-social"
                aria-label="Llamar por teléfono"
              >
                <span className="fas fa-phone-alt" aria-hidden="true"></span>
              </a>
            </div>
          </div>

          {/* Enlaces rápidos */}
          <nav className="col-6 col-md-4" aria-label="Enlaces rápidos">
            <h6 className="footer-title">Enlaces</h6>
            <ul className="list-unstyled m-0">
              <li><a className="footer-link" href="#inicio">Inicio</a></li>
              <li><a className="footer-link" href="#introduccion">Nosotros</a></li>
              <li><a className="footer-link" href="#objetivo">Objetivo</a></li>
              <li><a className="footer-link" href="#servicios">Servicios</a></li>
              <li><a className="footer-link" href="#especialidad">Especialidad</a></li>
              <li><a className="footer-link" href="#ubicacion">Ubicación</a></li>
              <li><a className="footer-link" href="#contacto">Contacto</a></li>
            </ul>
          </nav>

          {/* Contacto */}
          <div className="col-6 col-md-4">
            <h6 className="footer-title">Contacto</h6>
            <ul className="list-unstyled m-0">
              <li className="d-flex gap-2 align-items-start mb-2">
                <span className="fas fa-globe-americas mt-1" aria-hidden="true"></span>
                <a className="footer-link" href="https://www.kuelly.com.mx" target="_blank" rel="noopener noreferrer">
                  www.kuelly.com.mx
                </a>
              </li>
              <li className="d-flex gap-2 align-items-start mb-2">
                <span className="fas fa-envelope mt-1" aria-hidden="true"></span>
                <a className="footer-link" href="mailto:direccion@kuelly.com.mx">
                  direccion@kuelly.com.mx
                </a>
              </li>
              <li className="d-flex gap-2 align-items-start">
                <span className="fas fa-phone-alt mt-1" aria-hidden="true"></span>
                <a className="footer-link" href="tel:+524427989937">
                  +52 442 798 99 37
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Barra inferior */}
      <div className="footer-bottom py-3">
        <div className="container d-flex flex-column flex-md-row gap-2 justify-content-between align-items-center">
          <p className="m-0 small text-primary-custom">
            &copy; {new Date().getFullYear()} Kuelly. Todos los derechos reservados.
          </p>
          <div className="d-flex gap-3">
            <a className="footer-legal small" href="#">Aviso de Privacidad</a>
            <a className="footer-legal small" href="#">Términos y Condiciones</a>
          </div>
        </div>
      </div>

      {/* Botón volver arriba */}
      <a href="#inicio" className="back-to-top" aria-label="Volver al inicio">
        <span className="fas fa-arrow-up" aria-hidden="true"></span>
      </a>
    </footer>
  );
};

export default Footer;
